import styled from 'styled-components';

export const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  padding-top: calc(25% - 76px);
`;

export const MembersWrapper = styled.div`
  width: 95%;
  max-width: 1170px;
  margin: auto;
`;

export const AddMemberButton = styled.button`
  position: fixed;
  bottom: 40px;
  right: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.blueSecondary};
  border: 1px solid ${({ theme }) => theme.colors.grey007};
  border-radius: 4px;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.white};
`;

export const AddIcon = styled.span`
  margin-inline-end: 8px;
  &::after {
    content: ${'"\\e910"'};
    font-family: 'icomoon' !important;
    font-size: 12px;
  }
`;
